var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 125,
    viewBox: "0 0 202 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 125,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04784 30.4152L61.5285 30.4152L136.951 95.275L173.154 95.2749",
    stroke: "#74797D",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.106 30.4152L134.71 30.4152L59.2874 95.2749L7.99985 95.2749",
    stroke: "#74797D",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.628 94.7265C201.116 95.1266 201.116 95.8734 200.628 96.2735L172.027 119.709C171.374 120.244 170.393 119.779 170.393 118.936V72.0645C170.393 71.2205 171.374 70.7561 172.027 71.291L200.628 94.7265Z",
    fill: "#74797D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.056 28.7265C201.544 29.1266 201.544 29.8734 201.056 30.2735L172.455 53.709C171.802 54.2439 170.821 53.7795 170.821 52.9355V6.06449C170.821 5.22052 171.802 4.75608 172.455 5.29099L201.056 28.7265Z",
    fill: "#74797D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 125,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon);
export default __webpack_public_path__ + "static/media/state_icon.4a0f01c2214cf4cfe9802808974e0ed5.svg";
export { ForwardRef as ReactComponent };